// extracted by mini-css-extract-plugin
export default {"modalStyle":"Modal_modalStyle__yXdzJ","modalStyle__quadroModal":"Modal_modalStyle__quadroModal__cp-BO"};